module.exports = __webpack_public_path__ + "static/img/1958_Darmstadt_WaterMusic_7.31258bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_Darmstadt_WaterMusic_7.jpg
// module id = JZQj
// module chunks = 0